// extracted by mini-css-extract-plugin
module.exports = {"header":"kU3jU","title":"OnEZr","closeIcon":"GU5T7"};